import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import CollectionTable from '../components/CollectionTable';
import RepacksRetailBoxesSearchFilter from '../components/RepacksRetailBoxesSearchFilter';
import Avatar from 'material-ui/Avatar';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import Icon from 'material-ui/svg-icons/action/assignment-return';

export class RepacksRetailBoxes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterSubmitted: false,
            filterValues: {
                allowSearch: false,
                collectionType: '',
                dateFrom: '',
                dateTo: '',
                searchId: '',
                searchName: ''
            },
            listComplete: false,
            loading: false
        };
    }

    handleFilterSubmit = (obj) => {
        const allowSearch = !!(obj && obj.allowSearch);
        const searchId = (obj && obj.searchId && allowSearch) ? obj.searchId : '';
        const searchName = (obj && obj.searchName && allowSearch) ? obj.searchName : '';
        this.setState({
            filterSubmitted: true,
            filterValues: {
                allowSearch: allowSearch,
                collectionType: (obj && obj.collectionType) ? obj.collectionType : '',
                dateFrom: (obj && obj.dateFrom) ? obj.dateFrom : '',
                dateTo: (obj && obj.dateTo) ? obj.dateTo : '',
                searchId: searchId,
                searchName: searchName
            },
            loading: true,
            listComplete: false
        });
    };

    handleListComplete = (isComplete) => {
        this.setState({
            listComplete: isComplete,
            loading: false
        });
    };

    assembleText = (fv) => {
        let collectionType = 'Repacks and Retail Boxes';
        if (fv.collectionType === 'repack') {
            collectionType = ' Repacks';
        }
        if (fv.collectionType === 'retail_box') {
            collectionType = ' Retail Boxes';
        }
        let text = {
            loading: 'Searching ' + collectionType,
            title: collectionType
        };
        if (fv.allowSearch) {
            if (fv.searchId && fv.searchId !== '') {
                text.loading += ' with "' + fv.searchId + '"';
                text.title += ' containing "' + fv.searchId + '"';
            } else if (fv.searchName && fv.searchName !== '') {
                text.loading += ' with "' + fv.searchName + '"';
                text.title += ' containing "' + fv.searchName + '"';
            }
        }
        return text;
    };

    render() {
        const {
            filterSubmitted,
            filterValues,
            listComplete,
            loading
        } = this.state;

        const ListTitle = <span className="list-title">
            <Avatar icon={<Icon/>} className="avatar-title"/>Repacks / Retail Boxes</span>;

        const ListDescription = () => {
            return (
                <span>
                    <p>Search Repacks and Retail Boxes modified within a specified date range.</p>
                    <p>Optionally, enter a Collection ID or a Product name to search all Repacks and Retail
                        Boxes with that ID or Product.</p>
                    <p>To search for a Product name within a Repack or Retail Box, refer to
                        the <Link to="/TransferredProducts">Transferred Products</Link> section.</p>
                </span>
            );
        };

        const text = this.assembleText(filterValues);

        return (
            <div className="list-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        <RepacksRetailBoxesSearchFilter loading={loading} onSubmitFilter={this.handleFilterSubmit}/>

                        {filterSubmitted &&
                            <div>
                                {(loading || listComplete) &&
                                    <h3>{text.title}</h3>
                                }

                                {loading && !listComplete &&
                                    <div className="loader-container">
                                        <h4>{text.loading}...</h4>
                                        <CircularProgress
                                            size={24}
                                            thickness={2}
                                            className="loader"
                                        />
                                    </div>
                                }

                                <CollectionTable
                                    basePathCollections="InventoryRepacksRetailBoxes"
                                    filterValues={filterValues}
                                    listComplete={listComplete}
                                    onDataComplete={this.handleListComplete}
                                />
                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Fuse/Inventory/RepacksRetailBoxes.js